import { serverPostRequest } from '../../services/utilsServices';
import { wrapAutosuggestForLegacyUI } from '../../services/util/autosuggest';

const SA_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_SPONSORED_ADS_SECURE }`;

export const getAdChannelSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }ad-channel/autosuggest`);
export const getAdvertiserSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }advertiser/autosuggest`);
export const getAdvertiserRuleSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }traffic-rule/advertiser-rule/autosuggest`);
export const getCampaignSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }campaign/autosuggest`);
export const getContractSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }contract/autosuggest`);
export const getPublisherSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }publisher/autosuggest`);
export const getPublisherRuleSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }traffic-rule/publisher-rule/autosuggest`);
export const getSourceSASuggestions = serverPostRequest(`${ SA_SECURE_BASE_URL }sources/autosuggest`);


export const getContractAutosuggestSALegacy = wrapAutosuggestForLegacyUI(getContractSASuggestions);
